export enum NotificationsSummaryType {
  NOTIFICATION = 0,
  DELIVERIES_AND_SERVICES = 1,
  CREW_ENTRY = 2,
  CREW_DESCENT = 3,
}
